import { render, staticRenderFns } from "./BetTicketIdsArea.vue?vue&type=template&id=fba4cb48&"
import script from "./BetTicketIdsArea.vue?vue&type=script&lang=js&"
export * from "./BetTicketIdsArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports